import { render, staticRenderFns } from "./ReasonsForNotApproving.vue?vue&type=template&id=08a93f68&"
import script from "./ReasonsForNotApproving.vue?vue&type=script&lang=js&"
export * from "./ReasonsForNotApproving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports